var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47933 12.0533L12 21L20.5207 12.0533C21.4679 11.0587 22 9.70982 22 8.3033C22 5.37437 19.7387 3 16.9492 3C15.6097 3 14.325 3.55874 13.3778 4.5533L12 6L10.6222 4.5533C9.67499 3.55874 8.39031 3 7.05076 3C4.2613 3 2 5.37437 2 8.3033C2 9.70982 2.53213 11.0587 3.47933 12.0533Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05076 4C4.859 4 3 5.88012 3 8.3033C3 9.45992 3.43804 10.5599 4.20347 11.3636L12 19.55L19.7965 11.3636C20.562 10.5599 21 9.45992 21 8.3033C21 5.88012 19.141 4 16.9492 4C15.8911 4 14.8658 4.44091 14.1019 5.24296L12.7241 6.68966C12.5354 6.88784 12.2737 7 12 7C11.7263 7 11.4646 6.88784 11.2759 6.68966L9.89805 5.24296C9.1342 4.44091 8.10891 4 7.05076 4ZM1 8.3033C1 4.86862 3.6636 2 7.05076 2C8.6717 2 10.2158 2.67656 11.3463 3.86365L12 4.55L12.6537 3.86364C13.7842 2.67656 15.3283 2 16.9492 2C20.3364 2 23 4.86862 23 8.3033C23 9.95972 22.3738 11.5575 21.2448 12.743L12.7241 21.6897C12.5354 21.8878 12.2737 22 12 22C11.7263 22 11.4646 21.8878 11.2759 21.6897L2.75519 12.743C1.62622 11.5575 1 9.95972 1 8.3033Z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c0abdf0cbf8ef466a6796ca7d807b258.svg";
export { ForwardRef as ReactComponent };